var _style, _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _path3, _polyline, _path4, _path5, _line7, _path6, _path7, _polyline2, _polyline3, _path8, _path9, _path0, _line8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostureExercising(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:currentColor;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,34H4.7c0,0-1.8,0-2.2,1.5c0,0.4,0.1,1.4,2,1.5h29.8c0,0,2.1,0.4,2.2-1.5c-0.2-0.7,0.1-1.5-2.3-1.5 s-14,0-14,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.9,22.4H6.8c0,0-1.1,0.1-1.8-1.4s-2.1-5.6-2.1-5.6s-0.7-1.8,1.5-1.8c0.8,0,1.1-0.4,2,2S7.3,18,7.3,18 s0.1,1.5,2.2,1.5s4.9,0.1,4.9,0.1s1.8-0.2,1.7,1.6C16,21.6,16.1,22.5,13.9,22.4z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.7,
    y1: 22.4,
    x2: 8.7,
    y2: 34
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.5,
    y1: 21.8,
    x2: 5.5,
    y2: 33.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 29.5,
    y1: 20.8,
    x2: 37,
    y2: 20.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 30.7,
    y1: 15.5,
    x2: 35.8,
    y2: 15.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.2,
    y1: 10.8,
    x2: 34.7,
    y2: 10.8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28.3,
    y1: 6.6,
    x2: 31.9,
    y2: 6.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.4,10.8c0,0-1.5,2.9,0,4.8c0.8,0.6,1.8,1,0.4,2.9c-0.4,0.4-2.4,1.7-0.8,3.4c0.4,0.3,2.4,0.8,3-1.4 c0.2-0.4,0.7-1.4,1.1-2.5c0.6-0.8,2-1.7,0-3.5c-1.5-1.7-3.5-4.4-3.5-4.4L23.4,10.8z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "24.2,23.7 20.2,29.3 16.1,27 18.8,21.8 23.4,21.8 25.8,21.8 28.9,25.9 25.3,28.2 23.3,25.6 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19,21.3v-8.2l1.1-2.3c0,0,0.2-1.5-1.1-2.2c-0.4-0.3-0.7-1.2-0.5-3.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.7,10.1c0,0,3.1-1,2.2-4.8c-0.2-0.5-0.8-1.9-4.3-2.2c-1.7,0-4.4,0-4.4,0S16.7,5,20,5.2 C21.8,5.4,24.2,5.1,23.7,10.1z"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 20,
    y1: 10.8,
    x2: 24.2,
    y2: 10.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.4,34.5h-2.3c0,0-2.8,0-1.5,2.5C15.3,37.3,19,38,18.4,34.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.8,27.8v2.4c0,0,0.3,1.8,1.3,1.5c1-0.3,1.5-0.1,1.2-2.9C35.2,28.4,35.2,27.3,32.8,27.8z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "19.2,28.7 18.4,30.9 18.5,35 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "16.3,27.7 15.5,29.7 15.5,34.5 "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.5,27.8l1.3,1.9c0,0,0.6,0.8,1.8,0.8s3,0,3,0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.9,26.4c0,0,0.5,1.4,1.8,1.3c1.3-0.1,2.1,0.1,2.1,0.1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.4,16.1l-2.1,0.6c0,0-1.1,0.9-2-0.8c-0.9-1.7-2.1-4.3-2.1-4.3s-0.7-0.7-1.3-1.1s-0.6-2,0.3-2.5 c0.5-0.2,1.8-0.7,2.6,0.9c0.1,0.5-0.1,1,0.3,1.5c0.4,0.5,1.5,2.4,1.5,2.4s0.8,1.1,3.1,0.3"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.2,
    y1: 11.6,
    x2: 14.2,
    y2: 10.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostureExercising);
export default __webpack_public_path__ + "static/media/PostureExercising.eecd1e2f7e38bd6b24302575b603ce6e.svg";
export { ForwardRef as ReactComponent };